import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["abbreviate", "abbreviateThreshold", "value", "simplifyCurrency", "stripInsignificantZeros", "useCurrencyCode"];
import { Component } from 'react';
import I18n from 'I18n';
import formatCurrencyWithCode from '../utils/formatCurrencyWithCode';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Import from 'I18n/components/FormattedIntlCurrency' instead
 */
export default class FormattedCurrency extends Component {
  render() {
    const _this$props = this.props,
      {
        abbreviate,
        abbreviateThreshold,
        value,
        simplifyCurrency,
        stripInsignificantZeros,
        useCurrencyCode
      } = _this$props,
      options = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (simplifyCurrency && value % 1 === 0) {
      options.precision = 0;
    }
    if (useCurrencyCode) {
      options.unit = '';
      // @ts-expect-error passed to untyped I18n formatters
      options.useCurrencyCode = true;
    }
    if (stripInsignificantZeros === false) {
      // @ts-expect-error passed to untyped I18n formatters
      options.strip_insignificant_zeros = false;
    } else {
      // @ts-expect-error passed to untyped I18n formatters
      options.strip_insignificant_zeros = true;
    }
    const wrapperAttributes = {};
    if (abbreviate && (typeof abbreviateThreshold !== 'number' || typeof abbreviateThreshold === 'number' && value >= abbreviateThreshold)) {
      wrapperAttributes.title = I18n.formatCurrency(value, options);
      // @ts-expect-error passed to untyped I18n formatters
      options.abbreviate = true;
      options.precision = 0;
    }
    const formattedNumber = I18n.formatCurrency(value, options);
    const numberToRender = useCurrencyCode ?
    // @ts-expect-error Argument of type 'string | undefined' is not assignable to parameter of type 'string'
    formatCurrencyWithCode(formattedNumber, options.currencyCode) : formattedNumber;
    return /*#__PURE__*/_jsx("span", Object.assign({}, wrapperAttributes, {
      children: numberToRender
    }));
  }
}
FormattedCurrency.displayName = 'FormattedCurrency';
FormattedCurrency.contextType = I18nHMRContext;
FormattedCurrency.defaultProps = {
  stripInsignificantZeros: false,
  simplifyCurrency: false,
  formatNegativeValuesWithParenthesis: false
};